<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <div class="row mb-2">
              <div class="col-sm-8 ml-auto">
                <div class="text-right">
                  <router-link :to="{ name: 'site-faqs-new' }" class="btn btn-success btn-rounded mb-2">
                    <i class="mdi mdi-plus mr-1"></i> Nova Pergunta
                  </router-link>
                </div>
              </div>
            </div>

            <div class="table-responsive" v-if="list.length > 0">
              <table class="table table-centered table-nowrap">
                <thead class="thead-light">
                  <tr>
                    <th style="width: 70px;">#</th>
                    <th>Pergunta</th>
                    <th>Resposta</th>
                    <th style="width: 120px;">Status</th>
                    <th style="width: 100px;">Ações</th>
                  </tr>
                </thead>
                <draggable v-model="list" tag="tbody" @end="updateSequence" handle=".handle">
                  <tr v-for="(item, index) in list" :key="item.id">
                    <td class="handle" style="cursor: move;">
                      <div class="d-flex align-items-center">
                        <!-- <i class="mdi mdi-drag-vertical text-muted mr-2"></i> -->
                        <span class="badge badge-soft-primary font-size-12">{{ index + 1 }}</span>
                      </div>
                    </td>
                    <td>
                      <h5 class="font-size-14 mb-1">{{ item.question }}</h5>
                    </td>
                    <td>
                      <p class="text-muted mb-0" style="max-width: 400px;">
                        {{ item.answer.substring(0, 100) }}{{ item.answer.length > 100 ? '...' : '' }}
                      </p>
                    </td>
                    <td>
                      <div class="custom-control custom-switch">
                        <input
                          type="checkbox"
                          class="custom-control-input"
                          :id="'switch' + item.id"
                          :checked="item.status"
                          @change="toggleStatus(item.id)"
                        />
                        <label class="custom-control-label" :for="'switch' + item.id">
                          {{ item.status ? 'Ativo' : 'Inativo' }}
                        </label>
                      </div>
                    </td>
                    <td>
                      <router-link :to="{ name: 'site-faqs-edit', params: { id: item.id } }" class="mr-2">
                        <i class="mdi mdi-pencil font-size-18 text-success"></i>
                      </router-link>
                      <a href="#" @click.prevent="confirmDelete(item.id)">
                        <i class="mdi mdi-trash-can font-size-18 text-danger"></i>
                      </a>
                    </td>
                  </tr>
                </draggable>
              </table>
            </div>

            <div v-else class="text-center py-5">
              <i class="mdi mdi-help-circle-outline" style="font-size: 48px; color: #ced4da;"></i>
              <p class="text-muted mt-2">Nenhuma pergunta cadastrada</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>

<script>
import Layout from '@/components/layout/vertical'
import PageHeader from '@/components/page-header'
import draggable from 'vuedraggable'
import { mapActions, mapState } from 'vuex'
import { errorMessage, successMessage } from '@/components/alertsMessages'
import Swal from 'sweetalert2'

export default {
  components: { Layout, PageHeader, draggable },
  data () {
    return {
      title: 'Perguntas Frequentes',
      items: [{ text: 'Site', href: '/' }, { text: 'FAQs', active: true }],
      list: []
    }
  },
  computed: {
    ...mapState('faqs', { data: 'faqs' })
  },
  mounted () {
    this.loadFaqs()
  },
  methods: {
    ...mapActions('faqs', {
      fetch: 'GetFaqs',
      updateStatus: 'changeStatus',
      deleteItem: 'deleteFaq',
      reorder: 'orderList'
    }),
    async loadFaqs () {
      let loader = this.$loading.show()
      await this.fetch({ limit: 1000 })
      this.list = this.data.data || []
      loader.hide()
    },
    async toggleStatus (id) {
      try {
        await this.updateStatus(id)
        successMessage('Status atualizado!')
        this.loadFaqs()
      } catch (error) {
        errorMessage('Erro ao atualizar status.')
      }
    },
    async updateSequence () {
      try {
        const faqs = this.list.map(item => item.id)
        await this.reorder({ faqs })
        successMessage('Ordem atualizada!')
      } catch (error) {
        errorMessage('Erro ao reordenar.')
      }
    },
    confirmDelete (id) {
      Swal.fire({
        title: 'Tem certeza?',
        text: 'Esta ação não pode ser desfeita!',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#34c38f',
        cancelButtonColor: '#f46a6a',
        confirmButtonText: 'Sim, excluir!',
        cancelButtonText: 'Cancelar'
      }).then(async (result) => {
        if (result.value) {
          try {
            await this.deleteItem(id)
            successMessage('FAQ excluída!')
            this.loadFaqs()
          } catch (error) {
            errorMessage('Erro ao excluir.')
          }
        }
      })
    }
  }
}
</script>
